<p-toggleswitch 
    [ngModel]="checked"
    (ngModelChange)="onToggleChange($event)"
    [disabled]="disabled"
    [ngClass]="size"
    class="custom-toggle"
/>